
<template>
  <div class="top" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="top-t">
      <div class="f">{{itemData.highSpeedName}}途径城市数据</div>
      <div class="top-r">
        <div class="ser">
          <el-input placeholder="请输入搜索城市" v-model="searchData" clearable>
            <template slot="append"><span style="color: #fff;">搜索</span></template>
          </el-input>
          <div class="submit" @click="serData"></div>
        </div>
        <img width="18" src="../../../assets/images/iol.png" />
        <span>日均加油站停靠</span>
        <img width="18" src="../../../assets/images/day.png" />
        <span>日运营车次</span>
        <el-button class="close-btn" size="small" @click="goBack">关闭</el-button>
      </div>
    </div>
    <div class="way-c">
      <div
        v-for="(i,k) in listData"
        :key="k"
        :class="k==activeIndex?'a':''"
        @mouseover="overFun(k)"
        @click="clickfun(i)"
        @mouseout="outFun"
      >
        <div class="dot">{{k+1}}</div>
        <div class="rt">
          <div class="rt-l">{{i.cityName}}</div>
          <div class="rt-r">
            <div>
              <img width="18" src="../../../assets/images/day.png" />
              <span class="font-o">{{i.operationsRange}}</span>
            </div>
            <div>
              <img width="18" src="../../../assets/images/iol.png" />
              <span class="font-o">{{i.gasStationRange}}</span>
            </div>
          </div>
        </div>
        <div class="rb">
          <div>
            {{i.logisticsPark}}
            <div>
              物流园停靠
              <br />（日均）
            </div>
          </div>
          <div>
            {{i.density}}
            <div>城市加油站密度</div>
          </div>
          <div>
            {{i.lugNumber}}
            <div>
              LNG车次
              <br />（日均）
            </div>
          </div>
        </div>
      </div>
      <div v-if="listData.length==0" style="color: rgb(255, 255, 255); display: flex; justify-content: center;align-items: center; width: 100%; height: 90%;">暂无相关城市信息</div>
    </div>
  </div>
</template>
<script>
import axios from '@/api/road.js'
export default {
  data() {
    return {
      loading: false,
      id: null,
      searchData: '',
      itemData: {
        highSpeedName: 'G4京港澳高速'
      },
      listData: [],
      activeIndex: '-1'
    }
  },
  props: {
    clickId:Number
  },
  watch: {
    searchData(o,n){
      if(o==''){
        this.getList()
      }
    }
  },
  created() {
    // this.id = this.$route.query.id
    this.id=this.clickId
    this.getList()
  },
  methods: {
    clickfun(i) {
      this.$router.push({
        path: '/roadOperation/hotCities',
        query: { id: i.id, cityName: i.cityName, cityCode: i.cityCode }
      })
    },
    getList() {
      var _this = this
      axios.getRoadDetails(this.id, this.searchData).then(e => {
        if (e.data) {
          _this.listData = e.data.listData||[]
          _this.loading = false
        }
      })
    },
    serData() {
      this.getList()
    },
    goBack() {
       this.$parent.showwayCity=false
      // this.$router.go(-1)
    },
    // 鼠标放上去事件
    overFun(i) {
      this.activeIndex = i
    },
    outFun() {
      this.activeIndex = -1
    }
  }
}
</script>
